<!-- 问题状态-修改弹框 -->
<template lang="pug">
van-popup(v-model="popupShow" closeable round @closed="close")
  .statusArea
    span.title 修改状态
    .statusBtn
      span 状态
      .buttons
        van-button( v-for="(item,index) in statusDealList" :key="index" size="small" plain round :color="queColor(item)" @click="checkBtn(item)") {{ item.cnName }}
    .describe
      span 说明
      el-input(v-model="content" type="textarea" resize="none" :rows="3" placeholder="请填写说明")
    .bottom
      van-button(text="取消" type="info" round plain @click="popupShow = false")
      van-button(text="确认" type="info" round :disabled="!checkStatus.id" :loading="loading" @click="changeStatus")
</template>

<script>
import { mapState } from "vuex";
import { Notify } from "vant";
import { statusColor } from "@/CommonDP/pages/appView/issueH5/issue.js";
import questionService from "@/CommonDP/service/question-service";

export default {
  components: {},
  data() {
    return {
      popupShow: false,
      question: {},
      statusDealList: [], // 可用流转的状态
      checkStatus: {}, // 选中的状态
      content: "", // 说明
      loading: false
    };
  },
  computed: {
    ...mapState({
      enterpriseId: (state) => state.enterprise.enterpriseId,
      userId: (state) => state.user.userId
    }),
    // 是创建人
    isCreator() {
      let { creatorId } = this.question || {};
      if (creatorId === this.userId) return true;
      return false;
    },
    // 是处理人
    isHandler() {
      let { modifierList } = this.question || {};
      if (modifierList) {
        if (modifierList.some((e) => e.modifierId === this.userId)) return true;
      }
      return false;
    }
  },
  mounted() {},
  methods: {
    // 问题状态颜色
    queColor(item) {
      if (item.id !== this.checkStatus.id || !item.id) return "";
      return statusColor(item.id);
    },

    // 打开
    open(question) {
      this.popupShow = true;
      this.question = question || {};
      this.dealStatusList();
    },
    // 处理可用的流转状态
    async dealStatusList() {
      let { prjId, fileId, queStatus } = this.question || {};
      const { data } = await questionService.queryDict2(prjId, fileId);
      const { statusList } = data || {};
      let statusNames = [];
      switch (queStatus) {
        case "待修改":
          if (this.isCreator) statusNames = [...statusNames, "已取消"];
          if (this.isHandler) statusNames = [...statusNames, "已修改"];
          break;
        case "已修改":
          if (this.isCreator) statusNames = [...statusNames, "待修改", "已复核", "已取消"];
          if (this.isHandler) statusNames = [...statusNames, "待修改"];
          break;
        case "已复核":
          if (this.isCreator) statusNames = [...statusNames, "待修改", "已取消"];
          break;
        case "已取消":
          if (this.isCreator) statusNames = [...statusNames, "待修改"];
          break;
      }
      this.statusDealList = statusList?.filter((e) => statusNames.includes(e.cnName)) || [];
    },
    checkBtn(item) {
      this.checkStatus = item || {};
    },

    // 修改状态
    async changeStatus() {
      this.loading = true;
      try {
        let { prjId, questionId, queStatusId, queStatus } = this.question || {};
        let { id, cnName } = this.checkStatus || {};
        const params = {
          content: this.content,
          prjId,
          idList: [questionId],
          statusId: queStatusId,
          statusName: queStatus,
          toStatusId: id,
          toStatusName: cnName
        };
        await questionService.drawingannotationupdateStatus(params);
        Notify({ type: "success", message: "状态修改成功" });
        this.popupShow = false;
        this.$emit("callback");
      } finally {
        this.loading = false;
      }
    },
    // 关闭事件
    close() {
      this.question = {};
      this.statusDealList = [];
      this.checkStatus = {};
      this.content = "";
    }
  }
};
</script>

<style lang="scss" scoped>
.statusArea {
  width: 90vw;
  padding: 2vh 5vw;

  .title {
    font-size: 20px;
    line-height: 30px;
  }
  .statusBtn {
    margin-top: 10px;
    line-height: 30px;
    .buttons {
      padding-top: 10px;
      min-height: 42px;
      display: flex;
    }
    .van-button {
      width: 70px;
      margin-left: 0;
      margin-right: 8px;
    }
  }
  .describe {
    margin-top: 10px;
    line-height: 30px;
  }
  .bottom {
    width: 100%;
    display: flex;
    justify-content: space-around;
    .van-button {
      width: 300px;
      height: 40px;
      margin: 2vh 0 1vh;
      max-width: 40%;
    }
  }
}
</style>
